export default function AboutAllStore() {
  return (
    <div>
      AllStore
      <div>
        Extra Icons made from
        <a href="https://www.flaticon.com/" title="Flaticon">
          www.flaticon.com
        </a>
      </div>
    </div>
  );
}
